import Api from "./Api.js";
import qs from "qs";

const resource = "/notes";

export default {
  get(filters) {
    Object.keys(filters).forEach(
      key => filters[key] == null && delete filters[key]
    );
    return Api.get(`${resource}`, {
      params: filters,
      paramsSerializer: filters => {
        return qs.stringify(filters, {
          arrayFormat: "brackets",
          encode: false
        });
      }
    });
  },

  addNote(data) {
    return Api.post(`${resource}`, data);
  },
  getNote(id) {
    return Api.get(`${resource}/${id}`);
  },
  editNote(id, data) {
    return Api.post(`${resource}/${id}`, data);
  },
  getNotesByOrderNumber(orderNumber) {
    return Api.get(`${resource}/order/${orderNumber}`);
  },
  completeTask(id) {
    return Api.post(`${resource}/${id}/complete-task`);
  },
  cancelTask(id) {
    return Api.post(`${resource}/${id}/cancel-task`);
  },
  getTasks(params) {
    return Api.get(`${resource}/tasks`, {
      params: params
    });
  }
};
